import {
    ATTRIBUTE_OPTIONS,
    IMPACT_OPTIONS,
    TYPE_OPTIONS
} from "../misc/constants";
import { Col, Row } from "reactstrap";

import CommonModal from "@components/ui-components/modal";
import FormView from "@components/views/form-view";
import InputField from "@components/fields/input-field";
import Select from "@components/fields/react-select/select";
import useUpsert from "./use-upsert";

const UpsertHealthScore = props => {
    
    const {
        handleModalConfig,
        modalConfig: { isOpen, row }
    } = props;

    const isEdit = !!row._id;

    const { onSubmit, methods, updateLoading, isDirty } = useUpsert({
        ...props,
        isEdit
    });
    const {
        control,
        formState: { errors }
    } = methods;

    const content = [
        {
            leftChild: {
                title: "Basic Information",
                desc : "Please provide the basic information for the score."
            },
            rightChild: (
                <Row>
                    <Col lg={6}>
                        <Select
                            options={TYPE_OPTIONS}
                            errors={errors}
                            label="Type"
                            name="type"
                            id="type"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            id="name"
                            label="Name"
                            name="name"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={12}>
                        <InputField
                            errors={errors}
                            id="description"
                            type="textarea"
                            label="Description"
                            name="description"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={ATTRIBUTE_OPTIONS}
                            errors={errors}
                            label="Attribute"
                            name="attribute"
                            id="attribute"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <Select
                            options={IMPACT_OPTIONS}
                            errors={errors}
                            label="Impact"
                            name="impact"
                            id="impact"
                            control={control}
                            required/>
                    </Col>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            id="timeframe"
                            type="number"
                            desc="This is the timeframe (in days) for the health score to be calculated."
                            label="Timeframe"
                            name="timeframe"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            desc="The wost value for a metric in the health score. For e.g, number of events or amount of MRR"
                            id="worst_value"
                            type="number"
                            label="Worst Value"
                            name="worst_value"
                            required
                            control={control}/>
                    </Col>
                    <Col lg={6}>
                        <InputField
                            errors={errors}
                            desc="The best value for a metric in the health score. For e.g, number of events or amount of MRR"
                            id="best_value"
                            type="number"
                            label="Best Value"
                            name="best_value"
                            required
                            control={control}/>
                    </Col>
                </Row>
            )
        }
    ];
    return (
        <CommonModal
            title={`${isEdit ? "Edit" : "Add"} Score`}
            body={<FormView content={content} />}
            confirmButton={{
                txt    : isEdit ? "Update" : "Add",
                icon   : "content-save",
                onClick: onSubmit,
                loading: updateLoading
            }}
            type="fullScreen"
            isDirty={isDirty}
            handleModal={handleModalConfig}
            isOpen={isOpen}/>
    );
};
export default UpsertHealthScore;
